export default function Placeholder(){
    return(
        <div>
            <h1>Placeholder for future function</h1>
        </div>
    )
}